import React from 'react';
import {css} from 'emotion';
import logo from  '../../../image/logo/pnc_logo.jpg'
import Avatar from '../../common/avatar';
import {useSelector} from 'react-redux';
const Header = (props) =>{
  const info_user = useSelector(state=>state.user.info_user);
  return(
    <div className={css`position:fixed;left:0px;top:0px;z-index:100;width:100vw;height:60px;background-color:white;display:flex;flex-direction:row;border-bottom:1px solid #e8e8e8`}>
      <div className={css`display:flex;flex:1;justify-content:flex-start;height:100%`}><img className={css`height:100%;width:auto`} src={logo}/></div>
      <div className={css`display:flex;flex:1;justify-content:flex-end;height:100%;align-items:center;box-sizing:border-box;padding-right:20px`}>
        <div onClick={props.openMenuAccount} className={css`cursor:pointer`}><Avatar style={{height:'40px'}} id_avatar={parseInt(info_user.avatar, 10)}/></div>
      </div>
    </div>
  )
}

export default Header;
